const KatalReady = window.KatalReady = window.KatalReady || {};
export function fireReadyEvent(componentName, eventType) {
  if (KatalReady[componentName]) {
    return;
  }
  const event = new CustomEvent(eventType, {
    bubbles: true,
    detail: componentName
  });
  KatalReady[componentName] = true;
  document.dispatchEvent(event);
}
export const event = (name, options = false) => descriptor => ({
  ...descriptor,
  initializer() {
    return {
      emit: (detail = {}) => {
        const evt = new CustomEvent(name, {
          detail,
          ...(typeof options === 'boolean' ? {
            bubbles: options
          } : options)
        });
        return this.dispatchEvent(evt);
      }
    };
  }
});
//# sourceMappingURL=events.js.map